module.exports = __webpack_public_path__ + "img/Mortgage.4cb9977f.svg";